import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=5e65903e&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&id=5e65903e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e65903e",
  null
  
)

/* custom blocks */
import block0 from "./Items.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports